import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';

// eslint-disable-next-line react/prefer-stateless-function
class TaskPanelHeaderAsExec extends Component {
  getTitle = () => {
    if (this.props.typeLayout === 'view') {
      return this.props.task.title;
    }
    if (this.props.isTaskFromAuthUser) {
      return (
        <NavLink
          to={`/my-tasks/view/${this.props.task.id}/desc`}
          title={this.props.task.title}
        >
          {this.props.task.title}
        </NavLink>
      );
    }
    return (
      <NavLink
        to={`/earn-money/task-view/${this.props.task.id}`}
        title={this.props.task.title}
      >
        {this.props.task.title}
      </NavLink>
    );
  };

  render() {
    const title = this.getTitle();
    return (
      <div className="panel-heading panel-inner-border-bottom">
        <div className="task-table">
          <div className="task-cell">
            <h2 className="h3 task-title" title={this.props.task.title}>
              {title}
            </h2>
          </div>
          <div className="task-cell task-price">
            <div className="task-price-val">
              <span className="h3">{this.props.task.totalCostExecution}</span> ₽
            </div>
          </div>
        </div>
        <ul className="list-inline task-info">
          <li className="text-muted">
            {formatter.dateFormat3(this.props.task.createdAt)}
          </li>
          <li className="text-muted">ID{this.props.task.id}</li>
          <li title={`http://${this.props.task.taskDomain}`}>
            <a
              className="text-success text-underline"
              target="_blank"
              rel="noopener noreferrer"
              href={`http://${this.props.task.taskDomain}`}
            >
              {this.props.task.taskDomain}
            </a>
          </li>
          <li>
            <NavLink
              to={`/users/profile/${this.props.task.ownerId}`}
              className="text-muted"
            >
              <div className="media media_inline-table">
                <div className="media-left">
                  <img
                    alt={''}
                    className="media-object avatar avatar-xxs"
                    src={this.props.task.ownerAvatarPath}
                  />
                </div>
                <div className="media-body media-middle">
                  <div
                    className="text-overflow text-overflow_sm"
                    title={this.props.task.ownerUserName}
                  >
                    {this.props.task.ownerUserName}
                  </div>
                </div>
              </div>
            </NavLink>
          </li>
        </ul>
      </div>
    );
  }
}

TaskPanelHeaderAsExec.defaultProps = {
  typeLayout: 'list'
};

TaskPanelHeaderAsExec.propTypes = {
  isTaskFromAuthUser: PropTypes.bool.isRequired,
  typeLayout: PropTypes.oneOf(['list', 'view']),
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    taskDomain: PropTypes.string.isRequired,
    totalCostExecution: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    ownerId: PropTypes.number.isRequired,
    ownerUserName: PropTypes.string.isRequired,
    ownerAvatarPath: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(TaskPanelHeaderAsExec);



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TaskPanelHeaderAsExec/TaskPanelHeaderAsExec.js